import { LazyLoadImage } from 'react-lazy-load-image-component';
import Link from 'next/link';
import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { BlockContainer } from '@r1-frontend/ui-react/experimental/containers';

import { USER_LOGIN_ROUTE } from '~/src/constants/routes';

const AuthBanner = ({ ...props }) => {
    return (
        <BlockContainer rounder={{ $desktop: 32, $mobile: 24 }} indent={{ $desktop: [24, 40], $mobile: [24] }} {...props}>
            <H4>Авторизуйтесь, чтобы видеть персональные предложения</H4>
            <Link href={`${USER_LOGIN_ROUTE}?referrer=/subscriptions`} passHref>
                <Button bType='primary' size='medium'>Войти</Button>
            </Link>
            <WebpImage urlWebp='/static/images/subscriptions/banner/maskot.webp'>
                <LazyLoadImage src='/static/images/subscriptions/banner/maskot.png' alt='Изображение помошника в коробке' />
            </WebpImage>
        </BlockContainer>
    );
};

export default styled(AuthBanner)`
    flex-direction: column;
    background: 
        linear-gradient(107deg, #9BCDDD -5.78%, rgba(155, 205, 221, 0.00) 33.54%), 
        linear-gradient(307deg, #C1D1D9 -12.26%, rgba(196, 211, 218, 0.00) 31.41%),
        #E5F0F5;
  
    img, picture {
        position: absolute;
        bottom: 0;
        right: 40px;
        width: 197px;
        object-position: 0 32px;
    }

    ${Button} {
        width: max-content;
    }
  
    @media (max-width: ${wideBreakpoints.mobile}){
        img, picture  {
            right: 16px;
            bottom: 50%;
            transform: translateY(50%);
            width: 119px;
            object-position: center;
        }

        ${H4} {
            width: 182px;
        }
    }
`;
